import React, { lazy } from 'react'
import { useTranslations } from '@chilipiper/locale'
import { getDomain } from '@chilipiper/utils'
import { ProspectFormWithValidation } from '../availability/prospect/ProspectForm'
import { RouterLink } from './types'
import { RouteGuestLoaderView } from './RouteGuestLoaderView'

const RenderError = lazy(() => import('../availability/OnlineErrors'))

interface Props {
  create: boolean
  error?: string
  guests: string[]
  isLoading: boolean
  isSettingsActive?: boolean
  onProspectRoute: (_: unknown, prospect: Record<string, string>) => void
  onRouterFlow: (routerLink: RouterLink) => void
  onUpdateGuests: (guests: string[]) => void
  routerName: string
}

export const RouterGuestView = ({
  error,
  create,
  routerName,
  guests,
  onUpdateGuests,
  isSettingsActive,
  onProspectRoute,
  onRouterFlow,
  isLoading,
}: Props) => {
  const [pleaseWait] = useTranslations(['pleaseWait'])

  if (error) {
    return (
      <div className='routing-loader'>
        <div className='routing-loader-body'>
          <span>{error}</span>
        </div>
      </div>
    )
  }

  if (isSettingsActive === false) {
    return <RenderError code={9002} message='Forbidden' />
  }
  if (create) {
    return (
      <ProspectFormWithValidation
        //@ts-ignore: ProspectFormWithValidationConnected is jsx file this is inherited type error
        creation={true}
        hideBack={true}
        onRouterLink={onRouterFlow}
        onConfirm={onProspectRoute}
        routerName={routerName}
        domainFromUrl={getDomain()}
        guests={guests}
        updateGuests={onUpdateGuests}
      />
    )
  }
  if (isLoading) {
    return <RouteGuestLoaderView message='Searching for the best match for you' />
  }
  return <RouteGuestLoaderView message={pleaseWait} />
}
